// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CompareCardCheckbox_checkbox__jury7","picked":"CompareCardCheckbox_picked__HdObS"};